import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
const isDev = !environment.production
@Injectable({
  providedIn: 'root'
})
export class LogService {
  constructor() {

  }
  static debug(msg: any, describtion?: string): void {
    if (isDev) {
      console.debug(msg, describtion)
    }
  }
  info(msg: any): void {
    if (isDev) {
      console.info(msg)
    }
  }
  error(msg: any): void {
    throw new Error(msg)
  }
}
